/**
 * Helpers compartidos del módulo comercial.
 */
export const API_BASE = process.env.REACT_APP_API_URL || 'https://turismo.nara.chat/api';

export function getEmpresaId() {
  try {
    const ea = localStorage.getItem('empresa_activa');
    if (ea) return ea;
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return u.company_id || u.empresa_id || '1';
  } catch { return '1'; }
}

export function getCurrentUser() {
  try { return JSON.parse(localStorage.getItem('user') || '{}'); }
  catch { return {}; }
}

export function getUserRole() {
  const u = getCurrentUser();
  return (u.role || 'miembro').toLowerCase();
}

export function getUserId() {
  // El resto del proyecto guarda el id como string directo en `user_id`.
  // Fallback al objeto `user` por si solo está ahí.
  const direct = localStorage.getItem('user_id');
  if (direct) return direct;
  const u = getCurrentUser();
  return u.id || u.user_id || u._id || null;
}

export function getAuthHeaders() {
  const t = localStorage.getItem('token');
  const uid = getUserId();
  return {
    'Content-Type': 'application/json',
    ...(t ? { Authorization: `Bearer ${t}` } : {}),
    ...(uid ? { 'X-User-Id': String(uid) } : {}),
  };
}

export function formatPrecio(val, moneda = 'COP') {
  const n = Number(val) || 0;
  return new Intl.NumberFormat('es-CO', {
    style: 'currency', currency: moneda || 'COP',
    minimumFractionDigits: 0, maximumFractionDigits: 0,
  }).format(n);
}

export function formatFechaCorta(s) {
  if (!s) return '—';
  try {
    return new Date(s).toLocaleDateString('es-CO', {
      day: 'numeric', month: 'short', year: 'numeric',
    });
  } catch { return s; }
}

export function fechaRelativa(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    const diff = (new Date() - d) / 60000;
    if (diff < 1) return 'ahora';
    if (diff < 60) return `hace ${Math.round(diff)} min`;
    if (diff < 1440) return `hace ${Math.round(diff / 60)} h`;
    const dias = Math.round(diff / 1440);
    if (dias < 7) return `hace ${dias} d`;
    return d.toLocaleDateString('es-CO', { day: 'numeric', month: 'short' });
  } catch { return ''; }
}

export const PIPELINE_AGENCIA = [
  { value: 'prospecto', label: 'Prospecto', color: '#94a3b8' },
  { value: 'contactada', label: 'Contactada', color: '#0ea5e9' },
  { value: 'visitada',  label: 'Visitada',  color: '#8b5cf6' },
  { value: 'activa',    label: 'Activa',    color: '#16a34a' },
  { value: 'inactiva',  label: 'Inactiva',  color: '#f59e0b' },
  { value: 'perdida',   label: 'Perdida',   color: '#dc2626' },
];

export const PIPELINE_PROSPECTO = [
  { value: 'prospecto',  label: 'Prospecto',  color: '#94a3b8' },
  { value: 'contactado', label: 'Contactado', color: '#0ea5e9' },
  { value: 'visitado',   label: 'Visitado',   color: '#8b5cf6' },
  { value: 'propuesta',  label: 'Propuesta',  color: '#f59e0b' },
  { value: 'ganado',     label: 'Ganado',     color: '#16a34a' },
  { value: 'perdido',    label: 'Perdido',    color: '#dc2626' },
];

export const TEMPERATURAS = [
  { value: 'fria',     label: '🧊 Fría',     color: '#3b82f6' },
  { value: 'media',    label: '🌤️ Media',    color: '#f59e0b' },
  { value: 'caliente', label: '🔥 Caliente', color: '#dc2626' },
];

export const RESULTADOS_VISITA = [
  { value: 'positivo',    label: '✅ Positivo',     color: '#16a34a' },
  { value: 'neutro',      label: '➖ Neutro',       color: '#64748b' },
  { value: 'negativo',    label: '❌ Negativo',     color: '#dc2626' },
  { value: 'sin_contacto', label: '🚪 Sin contacto', color: '#94a3b8' },
];

export const CANALES_VISITA = [
  { value: 'presencial',    label: '🚶 Presencial' },
  { value: 'telefonica',    label: '📞 Telefónica' },
  { value: 'whatsapp',      label: '💬 WhatsApp' },
  { value: 'email',         label: '📧 Email' },
  { value: 'videollamada',  label: '📹 Videollamada' },
];
